<div class="fe-loader-container" [class.isOverflowing]="isOverflowing" [class.noBackground]="noBackground"
     [class.loaderPadding]="fromService">
    <mat-progress-spinner mode="indeterminate" diameter="60"
    [class.textMarginAuto]="loaderText.trim().length < 1"/>
    <span class="feLoaderText" *ngIf="loaderText.trim().length > 0">{{loaderText}}</span>
</div>